module.exports = __webpack_public_path__ + "static/sponsorship_img2@2x-d36b1e701311dbb002ca7042dbf9c8af.jpg";